let inputFilter = function() {	
	// this.searchFilter();
};
export default inputFilter;
